import { render, staticRenderFns } from "./InboxArticle.vue?vue&type=template&id=53c9657c"
import script from "./InboxArticle.ts?vue&type=script&lang=ts&external"
export * from "./InboxArticle.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports